import React from 'react';
import { numberWithCommas, subString } from '../../../utils/helpers';
import Image from '../../common/image';

const MillionairesClubTable = ({ data }) => {
	return (
		<div className='table-responsive'>
			<table className='table table-sm myTable text-center'>
				<thead>
					<tr>
						<th>Rank</th>
						<th>UID</th>
						<th>Email</th>
						<th>Score</th>
						<th>Possible Prize</th>
					</tr>
				</thead>
				<tbody>
					{data.map((d, key) => (
						<tr
							className='align-middle'
							key={key}>
							<td>{getRank(d.no)}</td>
							<td>{d.uid}</td>
							<td>{subString(d.email, 8, 6, '.')}</td>
							<td>
								<div className='d-flex align-items-center justify-content-center'>
									<span>{d.points}</span>
									<Image
										className='ms-2'
										height='30px'
										fileName='millionaires/point2.svg'
									/>
								</div>
							</td>
							<td>{getPrize(d.prize)}</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

const getRank = (no) => {
	if (no > 10) return no;
	return (
		<Image
			height='30px'
			fileName={`millionaires/clubRanks/${no}.svg`}
		/>
	);
};

const getPrize = (amnt) => {
	if (amnt)
		return (
			<>
				<b>$</b>
				<span>{numberWithCommas(amnt)}</span>
			</>
		);
	return <span>-</span>;
};

export default MillionairesClubTable;
